/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedRestrictedMaterialsLoader_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRestrictedMaterials_viewer">;
    readonly " $refType": "PdpSharedRestrictedMaterialsLoader_viewer";
};
export type PdpSharedRestrictedMaterialsLoader_viewer$data = PdpSharedRestrictedMaterialsLoader_viewer;
export type PdpSharedRestrictedMaterialsLoader_viewer$key = {
    readonly " $data"?: PdpSharedRestrictedMaterialsLoader_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRestrictedMaterialsLoader_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRestrictedMaterialsLoader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRestrictedMaterials_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd15903ca6efbbdf895843b6ad7eb06b8';
export default node;
